<template>

</template>

<script>
export default {
  name: 'receive-table'
}
</script>

<style scoped>

</style>
